import FlexChip from './flex-chip'

export const AmuiFlexChip = FlexChip

export default Vue => Vue.component(FlexChip.name, FlexChip)
